<template>
    <div class="component-centered-TransCAM" :class="{ 'mobile': estMobile }">
        <h1>TransCAM</h1>

        <div class="container-button">
            <label class="container-btn-choix-application" v-on:click="lancerVitale">
                <button class="btn-choix-application">
                    <img src="../../images/carte_vitale.png" alt="Carte Vitale" />
                    Lire Vitale
                </button>
            </label>
            <label class="container-btn-choix-application" v-on:click="lancerPatient">
                <button class="btn-choix-application">
                    <img src="../../images/patient.png" alt="Nom de l'image" />
                    Patients
                </button>
            </label>

            <label class="container-btn-choix-application" v-on:click="lancerGestion">
                <button class="btn-choix-application">
                    <img src="../../images/gestion.png" alt="Nom de l'image" />
                    Gestion
                </button>
            </label>

            <label class="container-btn-choix-application" v-on:click="lancerParametre">
                <button class="btn-choix-application">
                    <img src="../../images/settings.png" alt="Nom de l'image" />
                    Paramètres
                </button>
            </label>
            <!--<div class="container-btn-choix-application" v-on:click=""><button class="btn-choix-application"></button></div>-->
        </div>
        <router-view />
    </div>
</template>
<style scoped>
    h1 {
        text-align: center;
        /*color: forestgreen;*/
        color: #01358D;
        margin-bottom: 15px;
    }

    .container-button {
        display: grid;
        grid-template-columns: auto auto;
        grid-row-gap: 10px;
        grid-column-gap: 10px;
    }

    .component-centered-TransCAM {
        position: absolute; /* postulat de départ */
        top: 50%;
        left: 50%; /* à 50%/50% du parent référent */
        transform: translate(-50%, -50%); /* décalage de 50% de sa propre taille */
    }

    /* En mobile, le contenu dépasse la hauteur de l'écran : on l'aligne en haut
       (et on autorise le défilement) au lieu de le centrer verticalement,
       sinon le haut est coupé. */
    .component-centered-TransCAM.mobile {
        position: static;
        top: auto;
        left: auto;
        transform: none;
        width: fit-content;
        max-width: 100%;
        margin: 20px auto;
    }

    button {
        width: 160px;
        height: 160px;
        border-radius: 10px;
        color: white;
        background-color: cadetblue;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: none; /* Pour supprimer la bordure du bouton si nécessaire */
    }

        button:hover {
            background-color: lightgreen;
        }

        button img {
            max-width: 80px; /* Ajustez la taille de l'image selon vos besoins */
            margin-bottom: 10px; /* Ajoute un espacement entre l'image et le texte du bouton */
        }
</style>
<script>
    import { defineComponent } from 'vue';
    import RequestManager from '../../script/request.js';
    import { demanderPinSiRequis } from '@/script/pinCps';

    export default defineComponent({
        data: function () {
            return {
                message: 'Bienvenu dans la page choix TransCam !'
            }
        },

        computed: {
            estMobile() {
                return RequestManager.estMobile;
            }
        },

        methods: {
            lancerGestion() {
                this.$router.push('/transcam/Gestion');
            },

            lancerPatient() {
                this.$router.push('/transcam/Patient');
            },

            async lancerVitale() {
                //Trouver pk la
                //alert("On lance LireCarteVitale")
                let pin;
                try { pin = await demanderPinSiRequis(this.$store); }
                catch (e) { return; } // PIN annule -> on abandonne
                RequestManager.EnvoyerMessageWebView({ action: "LireCarteVitale", parameters: [pin] });
                this.$router.push('/transcam/LireCarteVitale');
            },

            lancerParametre() {
                this.$router.push('/transCam/parametre/');
            }

        },
        created() {
        },
        props: {

        }

    });
</script>
